import script from "./OAuthAuthorizeView.vue?vue&type=script&setup=true&lang=js"
export * from "./OAuthAuthorizeView.vue?vue&type=script&setup=true&lang=js"

import "./OAuthAuthorizeView.vue?vue&type=style&index=0&id=69ccbea9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69ccbea9"]])

export default __exports__